import React from 'react';
// import MaskedInput from 'react-maskedinput';
import MaskedInput from 'react-text-mask';

const CIRILLIC = /[А-ЕЖ-ЩЬЮЯЇІЄҐа-еж-щьюяїієґ]/;

export default function ChildBirthSertificateSeriesInput(props) {
  return (
    <MaskedInput
      {...props}
      // mask="\І-WW"
      mask={['І', '-', /[А-ЕЖ-ЩЬЮЯЇІЄҐа-еж-щьюяїієґ]/, /[А-ЕЖ-ЩЬЮЯЇІЄҐа-еж-щьюяїієґ]/]}
      guide={false}
      placeholderChar='*'
      // formatCharacters={{
      //   W: {
      //     validate: char => CIRILLIC.test(char),
      //     transform: char => char.toUpperCase()
      //   }
      // }}
    />
  );
}
